import api from "./api";

export const updateProfile = async (data) => {
  return await api.post("/users/admin/update", data);
};

export const changePassword = async (data) => {
  return await api.post("/users/update_password", data);
};


export const getUserProfile = async (userId) => {
    return await api.get(`/users/getOne/${userId}`);
};

export const getUserTotal = async () => {
  return await api.get(`/overview/totalUsers`);
  
};
export const getTotalStatus = async () => {
  return await api.get(`/overview//get-contentApproval-status`);
  
};